import { useEffect, useState } from "react";
import { useDataAccumulatorForSingleOrder } from "../../../context/dataAccumulatorForSingleOrder";
import { checkIfMultiplePastRegimenExists } from "../utils/checkIfMultiplePastRegimenExists";

/**
 * Returns `true` when the current order's auth-on-file data contains
 * J-codes with visit-chart data points that indicate multiple past regimens.
 */
export const useIfMultiplePastRegimenExists = () => {
  const { authOnFileDetails } = useDataAccumulatorForSingleOrder();
  const [ifMultiplePastRegimenExists, setIfMultiplePastRegimenExists] =
    useState(false);

  useEffect(() => {
    if (authOnFileDetails) {
      setIfMultiplePastRegimenExists(
        checkIfMultiplePastRegimenExists(authOnFileDetails?.auth_on_file ?? {}),
      );
    }
  }, [authOnFileDetails]);

  return ifMultiplePastRegimenExists;
};
